import { connect } from 'react-redux';

import DeclinedStatusActions from './component';

const mapStateToProps = () => ({});

export default connect(mapStateToProps)(DeclinedStatusActions);
